import React from "react"

import { AppOfficesBlock } from "@components/DataBlocks/index"
import AppListDialog, { listItemSx } from "@components/DataBlocks/ListDialog"
import { officeModalData } from "@signals"
import useOfficeModalFilter from "./@hooks"
import ModalOfficesSelector from "@components/DataBlocks/OfficesModal/Offices"
import ModalCountriesSelector from "@components/DataBlocks/OfficesModal/Countries"
import ModalTypesSelector from "@components/DataBlocks/OfficesModal/Types"


export default function AppOfficesModal({ ...props }) {

	const {
		filteredList,
		filteredOffices,
		onChangeOffice,
		onChangeCountry,
		onChangeType,
		typesOptions,
		countriesOptions,
		applyFilters
	} = useOfficeModalFilter()

	return <AppListDialog
		open={!!officeModalData.value?.length}
		onClose={() => officeModalData.value = []}
		icon="location-dot"
		title="Offices"
		noun="offices"
		total={officeModalData.value?.length || 0}
		shown={filteredList.length}
		containerProps={props.containerProps}
		filters={<>
			<ModalOfficesSelector
				applyFilters={applyFilters}
				filteredOffices={filteredOffices}
				onChangeOffice={onChangeOffice}
			/>
			<ModalCountriesSelector
				applyFilters={applyFilters}
				countriesOptions={countriesOptions}
				onChangeCountry={onChangeCountry}
			/>
			<ModalTypesSelector
				applyFilters={applyFilters}
				onChangeType={onChangeType}
				typesOptions={typesOptions}
			/>
		</>}
	>
		{filteredList.map(({ name, type, country }, idx) => (
			<AppOfficesBlock
				key={`${name}-${idx}`}
				name={name}
				type={type}
				country={country}
				{...props.officeProps}
				sx={{ ...listItemSx, ...props.officeProps?.sx }}
			/>
		))}
	</AppListDialog>
}
